// front/src/components/CibleSelector.jsx
import React, { useEffect, useState } from 'react';
import { ROLE_LABELS } from '../constants/roles';
import { useUser } from '../context/UserContext';

// Selecteur partage "role x etablissement" + liste de chips.
// Source unique pour la creation (TodoCreateModal) et la reaffectation (TodoReassignModal).
// value / onChange : tableau de cibles { role, etablissementId }.
export default function CibleSelector({
  roles = [],
  etabs = [],
  value = [],
  onChange,
  emptyLabel = 'Aucune cible ajoutée',
}) {
  const { etablissement } = useUser();
  const [role, setRole] = useState('');
  const [etab, setEtab] = useState('');

  // Initialise / reconcilie la selection courante quand les options arrivent.
  useEffect(() => {
    setRole((prev) => (roles.includes(prev) ? prev : roles[0] || ''));
  }, [roles]);

  useEffect(() => {
    const etablissementId = etablissement?.etablissement_id;
    setEtab(etabs.some((e) => e.id === etablissementId) ? etablissementId : etabs[0]?.id || '');
  }, [etabs]);

  const etabLabel = (id) => etabs.find((e) => e.id === id)?.libelle || id;

  const add = () => {
    if (!role || !etab) return;
    if (value.some((c) => c.role === role && c.etablissementId === etab)) return;
    onChange([...value, { role, etablissementId: etab }]);
  };
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div>
      <div className="flex gap-2">
        <select
          className="border rounded-lg px-2 py-2 text-sm"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          {roles.map((r) => (
            <option key={r} value={r}>
              {ROLE_LABELS[r] || r}
            </option>
          ))}
        </select>
        <select
          className="flex-1 border rounded-lg px-2 py-2 text-sm"
          value={etab}
          onChange={(e) => setEtab(e.target.value)}
        >
          {etabs.map((e) => (
            <option key={e.id} value={e.id}>
              {e.libelle}
            </option>
          ))}
        </select>
        <button
          type="button"
          onClick={add}
          className="rounded-lg border px-3 py-2 text-sm hover:bg-slate-50"
        >
          Ajouter
        </button>
      </div>
      <div className="flex flex-wrap gap-2 mt-2">
        {value.map((c, i) => (
          <span
            key={`${c.role}|${c.etablissementId}`}
            className="inline-flex items-center gap-2 bg-slate-100 rounded-full px-3 py-1 text-sm"
          >
            {ROLE_LABELS[c.role] || c.role} · {etabLabel(c.etablissementId)}
            <button
              type="button"
              onClick={() => remove(i)}
              className="text-slate-500 hover:text-red-600"
            >
              ×
            </button>
          </span>
        ))}
        {!value.length && <span className="text-xs text-slate-400">{emptyLabel}</span>}
      </div>
    </div>
  );
}
